import { useCallback } from "react";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { urlReplacer } from "../../../utils";
import { stringify } from "query-string";

export default function () {
  const { request } = useApi();

  return {
    create: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CREATE_PROGRAM_SECONDARY,
        });
      },
      [request],
    ),

    update: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "PUT",
          url: ApiRoutes.CREATE_PROGRAM_SECONDARY,
        });
      },
      [request],
    ),

    checkDuplication: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: `${urlReplacer(ApiRoutes.CHECK_PROGRAM_DUPLICATION_SECONDARY, {
            id: data.academicId,
          })}`,
        });
      },
      [request],
    ),

    activate: useCallback(
      async (id) => {
        return request({
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.ACTIVATE_PROGRAM_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    deactivate: useCallback(
      async (id, data) => {
        return request({
          data: data,
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.DEACTIVATE_PROGRAM_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    fetchAppCount: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${
            ApiRoutes.GET_APPLICATION_COUNT_FOR_DEACTIVATION_SECONDARY +
            stringify(filter)
          }`,
        });
      },
      [request],
    ),

    activateIntake: useCallback(
      async (id) => {
        return request({
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.ACTIVATE_INTAKE_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    deactivateIntake: useCallback(
      async (id, data) => {
        return request({
          data: data,
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.DEACTIVATE_INTAKE_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    deleteOneIntake: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_INTAKE_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    deleteOne: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_PROGRAM_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_PROGRAM_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    fetchAll: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${ApiRoutes.PROGRAMS_SECONDARY + stringify(filter)}`,
        });
      },
      [request],
    ),

    fetchCountriesContainingPrograms: useCallback(() => {
      return request({
        method: "GET",
        url: `${ApiRoutes.GET_COUNTRIES_CONTAINING_PROGRAMS_SECONDARY}`,
      });
    }, [request]),

    fetchViewMore: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_VIEW_MORE_PROGRAM_SECONDARY, {
            id,
          })}`,
        });
      },
      [request],
    ),
  };
}
